export default {
  title: {
    management: '应聘登记管理',
    invitation: '应聘登记邀请记录',
    question: {
      add: '新增问卷字段',
      edit: '编辑问卷字段'
    },
    step: {
      add: '新增问卷流程',
      edit: '编辑问卷流程'
    },
    questionnaire: {
      add: '新增问卷',
      edit: '编辑问卷'
    },
    microSite: {
      add: '新增问卷微网站',
      edit: '编辑问卷微网站'
    },
    emailTemplate: {
      add: '新增邮件模板',
      edit: '编辑邮件模板'
    },
    iconSelector: '选择图标',
    questionSelector: '选择问卷字段',
    stepSelector: '选择问卷流程'
  },
  menu: {
    management: '应聘登记管理',
    invitation: '应聘登记邀请记录'
  },
  tabMenu: {
    microSite: '问卷微网站',
    questionnaire: '问卷',
    step: '流程',
    question: '问题',
    emailTemplate: '邮件模板'
  },
  questionType: {
    text: '文本',
    date: '日期',
    single: '单选',
    multiple: '多选',
    attachment: '附件',
    link: '协议超链接',
    location: '所在地',
    country: '国家/地区',
    province: '省份',
    city: '城市',
    nationality: '国籍',
    language: '语言',
    nps: 'nps',
    stars: '六分制问题',
    signature: '手写签名'
  },
  questionnaireType: {
    general: '手动发送问卷'
  },
  language: {
    cn: '简体中文',
    tc: '繁体中文',
    en: '英文'
  },
  label: {
    question: '问卷字段',
    questionName: '字段名称',
    questionType: '字段类型',
    questionStatus: '字段状态',
    questionOption: '字段选项',
    questionConfig: '题型配置',
    prefillSource: '预填来源',
    dateFormat: '日期格式',
    minRows: '最少段数',
    maxRows: '最多段数',
    addButtonText: {
      cn: '添加按钮文案（简体中文）',
      tc: '添加按钮文案（繁体中文）',
      en: '添加按钮文案（英文）'
    },
    subFields: '子字段配置',
    subFieldNo: '子字段{number}',
    subFieldKey: '字段标识',
    subFieldType: '字段类型',
    subFieldTypeText: '文本',
    subFieldTypeDateRange: '日期范围',
    subFieldTypeSingle: '单选',
    required: '必填',
    width: '列宽',
    subFieldLabel: {
      cn: '标签（简体中文）',
      tc: '标签（繁体中文）',
      en: '标签（英文）'
    },
    subFieldPlaceholder: {
      cn: '占位符（简体中文）',
      tc: '占位符（繁体中文）',
      en: '占位符（英文）'
    },
    linkText: {
      cn: '协议文本（简体中文）',
      tc: '协议文本（繁体中文）',
      en: '协议文本（英文）'
    },
    linkUrl: {
      cn: '协议链接（简体中文）',
      tc: '协议链接（繁体中文）',
      en: '协议链接（英文）'
    },
    checkboxLabel: {
      cn: '勾选文案（简体中文）',
      tc: '勾选文案（繁体中文）',
      en: '勾选文案（英文）'
    },
    optionNo: '选项{number}',
    step: '问卷流程',
    stepName: '流程名称',
    stepIcon: '流程图标',
    stepStatus: '流程状态',
    isRequiredQuestion: '必填字段',
    questionnaireStatus: '问卷状态',
    questionnaireName: '问卷名称',
    questionnaireType: '问卷类型',
    scope: '问卷类型',
    micrositeName: '微网站名称',
    micrositeTitle: '标题',
    micrositeUrl: '预览链接',
    micrositeIsFinished: '完成设计',
    micrositeStatus: '状态',
    emailSubject: '邮件标题',
    emailType: '邮件类型',
    microsite: '微网站',
    invitationDate: '邀请日期',
    postApplicantDate: '完成日期',
    export: '导出',
    recruiter: '招聘人员',
    operation: '操作',
    questionnaire: '问卷',
    candidate: '求职者',
    company: '公司',
    job: '职位',
    status: '状态',
    finished: '已完成',
    unfinished: '未完成',
    keywordsSearch: '关键字搜索',
    noticeSuccessMessage: '提醒候选人成功！',
    operationBtn: {
      notice: '提醒候选人',
      cancel: '取消邀请',
      view: '查看候选人',
      reactivate: '重新激活',
      exportPdf: '下载PDF'
    },
    statusList: {
      all: '全部状态',
      invited: '已邀请',
      finished: '已完成',
      cancelled: '已取消'
    },
    title: {
      cn: '@:admin.company.jobApplication.language.cn标题',
      tc: '@:admin.company.jobApplication.language.tc标题',
      en: '@:admin.company.jobApplication.language.en标题'
    },
    name: {
      cn: '@:admin.company.jobApplication.language.cn名称',
      tc: '@:admin.company.jobApplication.language.tc名称',
      en: '@:admin.company.jobApplication.language.en名称',
      country: {
        cn: '国家/地区字段@:admin.company.jobApplication.language.cn名称',
        tc: '国家/地区字段@:admin.company.jobApplication.language.tc名称',
        en: '国家/地区字段@:admin.company.jobApplication.language.en名称'
      },
      province: {
        cn: '省份字段@:admin.company.jobApplication.language.cn名称',
        tc: '省份字段@:admin.company.jobApplication.language.tc名称',
        en: '省份字段@:admin.company.jobApplication.language.en名称'
      },
      city: {
        cn: '城市字段@:admin.company.jobApplication.language.cn名称',
        tc: '城市字段@:admin.company.jobApplication.language.tc名称',
        en: '城市字段@:admin.company.jobApplication.language.en名称'
      }
    },
    placeholder: {
      cn: '@:admin.company.jobApplication.language.cn占位符',
      tc: '@:admin.company.jobApplication.language.tc占位符',
      en: '@:admin.company.jobApplication.language.en占位符',
      country: {
        cn: '国家/地区字段@:admin.company.jobApplication.language.cn占位符',
        tc: '国家/地区字段@:admin.company.jobApplication.language.tc占位符',
        en: '国家/地区字段@:admin.company.jobApplication.language.en占位符'
      },
      province: {
        cn: '省份字段@:admin.company.jobApplication.language.cn占位符',
        tc: '省份字段@:admin.company.jobApplication.language.tc占位符',
        en: '省份字段@:admin.company.jobApplication.language.en占位符'
      },
      city: {
        cn: '城市字段@:admin.company.jobApplication.language.cn占位符',
        tc: '城市字段@:admin.company.jobApplication.language.tc占位符',
        en: '城市字段@:admin.company.jobApplication.language.en占位符'
      }
    },
    agreementLink: {
      cn: '@:admin.company.jobApplication.language.cn协议链接',
      tc: '@:admin.company.jobApplication.language.tc协议链接',
      en: '@:admin.company.jobApplication.language.en协议链接'
    },
    agreementText: {
      cn: '@:admin.company.jobApplication.language.cn协议文本',
      tc: '@:admin.company.jobApplication.language.tc协议文本',
      en: '@:admin.company.jobApplication.language.en协议文本'
    }
  },
  placeholder: {
    searchKeyword: {
      question: '请输入字段名称',
      step: '请输入流程名称'
    },
    questionnaireName: '请输入问卷名称',
    step: '请选择问卷流程',
    stepName: '请输入流程名称',
    question: '请选择问卷字段',
    questionName: '请输入字段名称',
    questionType: '请选择字段类型',
    questionConfig: '请输入题型 JSON 配置',
    prefillSource: '请选择预填来源',
    linkText: '请输入协议文本',
    linkUrl: '请输入协议链接',
    subFieldKey: '请输入字段标识',
    width: '请输入列宽，如 180px',
    subFieldLabel: '请输入子字段标签',
    subFieldPlaceholder: '请输入子字段占位符',
    agreementLink: '请输入协议链接',
    placeholder: '请输入占位符',
    optionName: '请输入选项名称',
    questionnaireType: '请选择问卷类型',
    questionnaireStatus: '请选择问卷类型',
    emailSubject: '请输入邮件标题',
    emailTemplate: '请输入邮件模板',
    micrositeName: '请输入微网站名称',
    selectMicrositeName: '请选择微网站名称'
  },
  message: {
    questionNameRequired: '请输入字段名称',
    questionTypeRequired: '请选择字段类型',
    questionConfigInvalid: '题型配置不是有效 JSON',
    maxRowsInvalid: '最多段数不能小于最少段数',
    subFieldRequired: '请完善子字段的字段标识、字段类型和三语标签',
    subFieldTypeUnsupported: '当前版本暂不支持子字段单选题',
    agreementTextRequired: '请输入协议文本',
    agreementLinkRequired: '请输入协议链接',
    optionNameRequired: '请输入选项名称',
    stepNameRequired: '请输入流程名称',
    stepQuestionsRequired: '请选择问卷字段',
    NPSQuestionSingle: '一个调查只能有一个净推荐值问题',
    stepIconRequired: '请选择流程图标',
    questionnaireStepsRequired: '请选择问卷流程',
    questionnaireNameRequired: '请输入问卷名称',
    questionnaireMicroSiteRequired: '请选择微网站',
    NPSStepSingle: '一个调查只能有一个净推荐值问题',
    signatureQuestionSingle: '一份应聘登记表只能有一个手写签名问题',
    questionnaireTypeRequired: '请选择问卷类型',
    scopeRequired: '请选择问卷类型',
    emailSubjectRequired: '请输入邮件标题',
    emailTemplateRequired: '请输入邮件模板',
    emailTemplateTip: {
      warn: `
        下方编辑框支持使用形如<span class="strong">{{first_name}}</span>的占位符，发送正式邀请时系统会按实际应聘登记邀请替换。
        <br/>
        请<span class="strong">不要</span>修改占位符名称；您可以调整占位符所在文字或二维码的样式。
      `,
      description: `
        <tr>
          <th>占位符</th>
          <th>值/描述</th>
        </tr>
        <tr>
          <td>{{questionnaire_page_link}}</td>
          <td>应聘登记答题链接</td>
        </tr>
        <tr>
          <td>{{job_application_page_qrcode}}</td>
          <td>应聘登记答题链接二维码，二维码可点击打开答题链接</td>
        </tr>
        <tr>
          <td>{{first_name}}</td>
          <td>所邀请求职者的名字</td>
        </tr>
        <tr>
          <td>{{last_name}}</td>
          <td>所邀请求职者的姓氏</td>
        </tr>
        <tr>
          <td>{{hr_first_name}}</td>
          <td>HR的名字</td>
        </tr>
        <tr>
          <td>{{hr_last_name}}</td>
          <td>HR的姓氏</td>
        </tr>
        <tr>
          <td>{{candidate_profile_link}}</td>
          <td>求职者个人信息页面链接</td>
        </tr>
        <tr>
          <td>{{questionnaire_page_qrcode}}</td>
          <td>事件二维码</td>
        </tr>
      `
    },
    testEmailHasSent: '测试邮件发送成功！'
  },
  microsite: {
    pcOrMobile: '电脑/手机',
    micrositeName: '微网站名称',
    micrositeLink: '微网站链接',
    webEnLink: '电脑端 （英文）',
    webCnLink: '电脑端 （简中）',
    webTcLink: '电脑端 （繁中）',
    mobileEnLink: '手机端 （英文）',
    mobileCnLink: '手机端 （简中）',
    mobileTcLink: '手机端 （繁中）'
  },
  headerImage: {
    tipMessage: {
      pc: '推荐大小为：1920*750且小于5MB',
      mobile: '推荐大小为：750*1100且小于5MB'
    }
  }
}
